import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Label, Icon } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import { campaignStatus, getCampaignStatus } from '../../utils/campaign-status';

const labelStyle = {
  width: '100%',
};
const BASIC_DATA_FORMAT = 'll';

const CampaignStatusComponent = campaign => {
  const liveDate = _.get(campaign, 'liveDate', null);
  const endDate = _.get(campaign, 'endDate', null);

  const liveMoment = moment(liveDate);
  const endMoment = moment(endDate);
  let status;

  const cStatus = getCampaignStatus(campaign);

  if (cStatus === campaignStatus.INVALID) return (<div />);

  if (cStatus === campaignStatus.FUTURE) {
    status = {
      color: 'blue',
      text: 'future',
      content: `Campaign will start on ${liveMoment.format(BASIC_DATA_FORMAT)}`,
    };
  }

  if (cStatus === campaignStatus.LIVE) {
    status = {
      color: 'green',
      text: 'LIVE',
      icon: 'play circle outline',
      content: `Campaign will end on ${endMoment.format(BASIC_DATA_FORMAT)}`,
    };
  }

  if (cStatus === campaignStatus.COMPLETED) {
    status = {
      color: 'orange',
      text: 'complete',
      content: `Campaign completed on ${endMoment.format(BASIC_DATA_FORMAT)}`,
    };
  }

  return status ? (
    <div style={{ paddingTop: '3px' }}>
      <Popup
        trigger={
          <Label size="tiny" basic color={status.color} style={labelStyle}>
            {status.text} {status.icon && <Icon name={status.icon} size="large" />}
          </Label>}
        content={status.content}
      />
    </div>
  ) : <div />;
};


CampaignStatusComponent.propTypes = {
  liveDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default CampaignStatusComponent;



/** WEBPACK FOOTER **
 ** ./src/components/campaigns-table/campaign-status-component.js
 **/